import "./Footer.css";
import React from "react";
import {useTranslation} from "react-i18next";
import useTheme from "../../ThemeProvider.ts";

function Footer() {
  const { t } = useTranslation();

  const theme = useTheme()

  return (
      <footer id={"footer"} className={"site-footer"}>
        <div className={'footer'}>
          <div className={"newsletter-form"}>
            <a href={"https://antenna.gr/"}><img src={'https://antenna.gr/images/logo.svg'} alt="ant1 logo" className={'footer-logo'}/></a>
            <h5 className="sm-title">Social Media Accounts</h5>
            <div className={"socialmediaicons"}>
              <ul>
                <li>
                  <a href={'https://www.facebook.com/ANT1plus/'}>
                    <img src="images/footer/v2/facebook.svg" alt="Facebook icon"/>
                  </a>
                </li>
                <li>
                  <a href={'https://x.com/Ant1_plus'}>
                    <img src="images/footer/v2/x.svg" alt="X icon"/>
                  </a>
                </li>
                <li>
                  <a href={'https://www.instagram.com/ant1plus_official/'}>
                    <img src="images/footer/v2/instagram.svg" alt="Instagram icon"/>
                  </a>
                </li>
                <li>
                  <a href={'https://www.youtube.com/channel/UCGCzXaMVL_GQFZJFVOZ_Ppg'}>
                    <img src="images/footer/v2/youtube.svg" alt="Youtube icon"/>
                  </a>
                </li>
                <li>
                  <a href={'https://www.tiktok.com/@ant1plus'}>
                    <img src="images/footer/v2/tiktok.svg" alt="Tiktok icon"/>
                  </a>
                </li>
              </ul>
            </div>
            <ul className={"footer-list"}>
              <li>
                <a href={'https://help.antennaplus.gr/contact-us/'}>
                  {t("footer.idp.contactUs")}
                </a>
              </li>
              <li>
                <a href={"https://apply.workable.com/antenna/?lng=el"}>
                  {t("footer.idp.workable")}
                </a>
              </li>
              <li>
                <a href={theme.uris.other.termsAndConditions}>
                  {t("footer.idp.terms")}
                </a>
              </li>
              <li>
                <a onClick={() => window.__tcfapi('displayConsentUi', 2, function () {
                })}>
                  {t("footer.idp.cookies")}
                </a>
              </li>
              <li>
                <a href={"https://antenna.gr/dataprotection"}>
                  {t("footer.idp.dataProtection")}
                </a>
              </li>
            </ul>
            <ul className={"footer-list"}>
              <li>
                <a href={'https://help.antennaplus.gr/kb/τι-είναι-το-αντ1/'}>
                  {t("footer.idp.aboutUs")}
                </a>
              </li>
              <li>
                <a href={"https://antenna.gr/applications"}>
                  {t("footer.idp.apply")}
                </a>
              </li>
              <li>
                <a href={'https://antenna.gr/links'}>
                  {t("footer.idp.links")}
                </a>
              </li>
              <li>
                <a href={"https://antenna.gr/press"}>
                  {t("footer.idp.press")}
                </a>
              </li>
              <li>
                <a href={'https://antenna.gr/competition-winners'}>
                  {t("footer.idp.competitionWinners")}
                </a>
              </li>
              <li>
                <a href={'https://antenna.gr/competition-terms'}>
                  {t("footer.idp.competitionTerms")}
                </a>
              </li>
              <li>
                <a href={'https://antenna.gr/identity'}>
                  {t("footer.idp.identity")}
                </a>
              </li>
            </ul>
            <div className="mit_ant"><img src="https://antenna.gr/images/MHT_antenna_2.png" alt="MHT"/></div>
            <p className="copyright">Copyright © 2024 ANTENNA TV S.A. All rights reserved.</p>
            <p className="copyright2"> CREATED BY ANT1 DIGITAL</p>
          </div>
        </div>
      </footer>);
}

export default Footer;
